import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { fromEvent, merge, Observable, timer } from 'rxjs';
import { debounce, map } from 'rxjs/operators';
import { LabelsDataService } from '../../../services/labels-data.service';
import { SubscriptionHandler } from '../../components/subscriptionHandler';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { EmailFormControl } from './email-form-control';

@Component({
  standalone: false,
  selector: 'app-email-form-control',
  templateUrl: './email-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailFormControlComponent),
      multi: true
    }
  ]
})
export class EmailFormControlComponent
  extends AbstractFormControlComponent<EmailFormControl>
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  faCheck: any = faCheck;
  subscriptionHandler: SubscriptionHandler = new SubscriptionHandler();
  onChange: any = (value: string) => {};
  onTouched: any = () => {};
  requiredText: string = '';

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    this.onChanged.emit(this.control.value);
  }

  constructor(public labelsDataService: LabelsDataService) {
    super();
  }

  ngOnInit(): void {
    this.subscriptionHandler.subscriptions = this.bindKeypressEvent().subscribe(($event: KeyboardEvent) =>
      this.onKeyPress($event)
    );

    this.requiredText = this.labelsDataService.getData('COMMON.PleaseFillInThisFieldText');
  }

  ngOnDestroy(): void {
    this.subscriptionHandler.unsubscribeAll();
  }

  public get minLength(): number {
    return this.control.minLength;
  }

  public get maxLength(): number {
    return this.control.maxLength;
  }

  onKeyPress($event: KeyboardEvent) {
    if (($event.ctrlKey || $event.metaKey) && $event.keyCode == 86) {
      this.onChanged.emit(this.control.value);
    }
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  private bindKeypressEvent(): Observable<KeyboardEvent> {
    const eventsType$ = [fromEvent(window, 'keypress'), fromEvent(window, 'keydown')];

    return merge(...eventsType$).pipe(
      debounce(() => timer(10)),
      map(state => state as KeyboardEvent)
    );
  }
}
